import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StarContainer = styled.button`
  width: 16px;
  height: 100%;
  margin: auto 0;
  padding: 0;
  border: none;
  outline: none;
  background: none;

  &.on {
    span {
      color: ${props => props.theme.reviews.star.on};
    }
  }

  &.off > {
    span {
      color: ${props => props.theme.reviews.star.off};
    }
  }
`;

export const Star = styled.span`
  width: 16px;
  height: 16px;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(16)};

  @-moz-document url-prefix() {
    font-size: ${props => props.theme.rem(22)};
  }
`;

export const Count = styled.span`
  position: relative;
  font-size: ${props => props.theme.rem(26)};
  line-height: ${props => props.theme.rem(32)};
  color: ${props => props.theme.reviews.text};
  margin: 0 2px;
`;
